<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>

<div class="mt-34 ml-24 mr-24">
  <div *ngIf="!isLoading && roles; else loader">
    <div class="mat-subtitle-1 fw-600">
      {{'ROLES.ROLES' | transloco }}
    </div>
    <div class="roles-table mt-28" *ngIf="data?.length > 0; else noDataFound">
      <div class="header flex pl-30 pt-12 pb-12">
        <div class="roles-name mat-subtitle-2 fw-700 fs-14">{{ 'ROLES.ROLE_NAME' | transloco | uppercase }}</div>
        <div class="roles-desc mat-subtitle-2 fw-700 fs-14">{{ 'ROLES.DESCRIPTION' | transloco | uppercase }}</div>
      </div>
      <ng-container *ngFor="let role of data; let last = last">
        <div class="body flex pl-30 pt-12 pb-12" [ngClass]="{'body-element': !last}">
          <div class="roles-name flex items-center" (click)="goToPermissions(role)">
            <div><img class="account" src="/assets/images/account.svg"/></div>
            <div class="name  fw-500 cursor-pointer ml-8">{{role?.name}}</div>
          </div>
          <div class="roles-desc fw-500">
            {{role?.description ? (role?.description | titlecase) : '-'}}
          </div>
        </div>
      </ng-container>
    </div>
    <ng-template #noDataFound>
      <div class="no-data mt-16 flex items-center justify-center">{{ 'GROUPS.NO_DATA_FOUND' | transloco }}</div>
    </ng-template>
  </div>
  <ng-template #loader>
    <div *ngIf="isLoading" class="flex spinner-container spinner">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </div>
  </ng-template>
  <div *ngIf="permissions && !isLoading">
    <div class="top-panel p-24 mb-28 flex flex-row justify-start items-center">
      <mat-icon svgIcon="arrow_back" class="cursor-pointer icon-lg" (click)="goToRoles()"></mat-icon>
      <div class="pl-24"><img class="account-icon" src="/assets/images/account.svg"/></div>
      <div *ngIf="selectedRole" class="flex flex-col pl-16">
        <div class="mat-headline-5 fw-700 mb-14">
          {{ selectedRole?.name | titlecase }}
          <span class="fs-14 fw-500 permission-text pt-4 pb-4 pl-12 pr-12 mat-body ml-32">{{ 'ROLES.VIEW_PERMISSION' | transloco }}</span>
        </div>
        <div class="mat-body fw-500 fs-16">
          {{ selectedRole?.description | titlecase }}</div>
      </div>
    </div>

    <div class="mb-16 mat-subtitle-2 fs-12 fw-700">
      {{ 'ROLES.RESOURCE' | transloco | uppercase }}
    </div>
    <div class="flex flex-wrap gap-3">
      <div class="pt-8 pb-8 pl-16 pr-16 tab-names cursor-pointer mat-subtitle-2 fs-16 fw-600" [ngClass]="{'selected': permission?.isSelected}"
        *ngFor="let permission of permissionsData" (click)="selectPermission(permission)">
        {{permission.header === ('ROLES.INSTANCE' | transloco) ? ('INSTANCE_DETAILS.INSTANCE' | transloco) : permission.header}}
      </div>
    </div>

    <div class="permissions-table mt-32">
      <ng-container *ngIf="selectedPermission?.key !== 'instance' && selectedPermission?.key !== 'jumpboxes' && selectedPermission?.key !== 'pe-connections' && selectedPermission?.key !== 'authz' && selectedPermission?.key !== 'runbook' && selectedPermission?.key !== 'schedules' && selectedPermission?.key !== 'jobs'">
        <div class="others-header flex">
          <div class="permission-header mr-24 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
        </div>
        <div class="pb-20">
          <ng-container *ngFor="let permission of selectedPermission.permissions">
            <div class="others-section flex" *ngIf="!permission.dataZonePermissions">
              <div class="permission pl-24 flex items-center mr-24 fw-500">
                {{permission?.header}}
              </div>
              <div class="element pl-24 flex items-center mr-24 fw-500">
                <mat-icon [svgIcon]="permission?.access ? 'done' : 'close'" [ngClass]="{'close': !permission?.access}"  class="icon-md-1"></mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="dataZonePermissions(selectedPermission.permissions)">
        <div class="header flex">
          <div class="permission mr-24 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex pl-20">{{ 'ROLES.PERMISSIONS' | transloco }}</div>
          <div class="nonpii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.READ' : 'ROLES.NON_PII') | transloco }}</div>
          <div class="pii mr-16 mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.CREATE' : 'ROLES.PII') | transloco }}</div>
          <div class="live mat-subtitle-2 fw-600 fs-20 pt-12 pb-12 flex justify-center">{{ (selectedPermission?.key === 'authz' ? 'ROLES.UPDATE' : 'ROLES.PROD') | transloco }}</div>
        </div>
        <ng-container *ngFor="let permission of selectedPermission.permissions">
          <div class="body flex" *ngIf="permission.dataZonePermissions">
            <div class="permission pl-24 flex items-center mr-24 fw-500">
              {{permission?.header}}
            </div>
            <ng-container *ngFor="let element of permission.dataZonePermissions; let last = last">
              <div class="element flex items-center justify-center fw-500" [ngClass]="{'mr-16': !last}">
                <div>
                  <mat-icon [svgIcon]="element?.access ? 'done' : 'close'" [ngClass]="element?.access && element?.infoDetails && element?.infoDetails?.length > 0 ? 'done' : !element?.access ? 'close' : ''"  class="icon-md-1"></mat-icon>
                </div>
                <span *ngIf="element?.access && element?.infoDetails && element?.infoDetails?.length > 0" class="info-icon">
                  <mat-icon svgIcon="info" class="icon-sm cursor-pointer" [matMenuTriggerFor]="tooltipContent"></mat-icon>
                </span>
                <mat-menu #tooltipContent [xPosition]="'before'" class="roles-tooltip">
                  <div class="p-12">
                    <div class="type-header mat-subtitle-2 fs-14 fw-600 pb-4 mb-8">{{'ROLES.INSTANCE_TYPE' | transloco}}</div>
                    <div class="fs-14 fw-500" *ngFor="let type of element?.infoDetails; let i = index">
                      {{i + 1}}.<span class="pl-4">{{ type === 'others' ? (type | titlecase) : (type | uppercase)}}</span>
                    </div>
                  </div>
                </mat-menu>
              </div>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

